import css from './Tooltip.module.css';

function Tooltip({ tooltip }) {
  return (
    <div className={css.tooltip} style={{ top: tooltip.y + 15, left: tooltip.x + 15 }}>
      <div dangerouslySetInnerHTML={{ __html: tooltip.content }} />
      <div className={css.tooltipArrow}></div>
    </div>
  );
}

export default Tooltip;
